import StateType from './state.type';

export default {
  loading: false,
  loadingSave: false,
  billingConfiguration: {},
  preSignedUrlCertificate: null,
  preSignedUrlLogo: null,
} as StateType;
